// Lookups owned by the holiday form's Canton multi-select. Kept apart from queries.ts so the form
// can evolve on its own (mirrors hr-directory's contact-info-lookups.ts).
import { buildPagingLiteral, buildWhereLiteral } from '@/lib/graphql-query-builder';

/**
 * Cantons / divisions / districts / states of the active organization (the `Location` schema's
 * `State`), for the holiday form's Canton multi-select — same schema hr-directory's contact info
 * step reads. The organization stands for the country, so no region filter is needed.
 */
export const buildGetHolidayCantonsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    Locations: getLocations(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ItemId
        State
      }
    }
  }
`;
